import {Spin} from "antd";
import {COLOR_MUTED} from "App";
import { LoadingOutlined } from '@ant-design/icons';

import React from "react";

export function AppLoader() {
    return (
        <Spin
            spinning={true}
            size="large"
            indicator={<LoadingOutlined style={{ fontSize: 48 }} spin />}
        >
            <div
                className="container-card--holotrak"
                style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    height: "100vh",
                    width: "100vw",
                    background: "#fff",
                }}>
                <p>
                    <strong>Loading...</strong>
                </p>
                <p>
                    <em style={{color: COLOR_MUTED}}>
                        Holotrak v{process.env.REACT_APP_VERSION}
                    </em>
                </p>
            </div>
        </Spin>
    );
}
